import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const Title = () => {
    const { t } = useGranite();

    return <h3>{t("store.detail.features.title")}</h3>;
};

export { Title };
